import Vue from 'vue'
import Client from '../services/client'
import Notifications from '../components/notifications.vue'

const { DateTime } = require('luxon')

const el = document.querySelector('#notifications')
if (el !== null) {
  const vm = new Vue({
    data () {
      return {
        siteId: null,
        notifications: []
      }
    },
    components: {
      Notifications
    },
    delimiters: ['[[', ']]'],
    methods: {
      getNotifications () {
        Client.getNotifications(this.variables)
          .then(response => {
            if (response.data.data.globalSet) {
              this.notifications = response.data.data.globalSet.notifications
            } else {
              this.notifications = []
            }
          })
          .catch(error => {
            console.log('Notifications error: ', error)
          })
      }
    },
    computed: {
      currentNotifications () {
        const now = DateTime.local()
        const today = now.toFormat('yyyyMMdd')
        return this.notifications.filter(item =>
          (parseInt(item.startDate) <= today &&
            item.endDate == null) ||
          (parseInt(item.startDate) <= today &&
            parseInt(item.endDate) >= today)
        )
      },
      variables () {
        return {
          siteId: this.siteId
        }
      }
    },
    mounted () {
      this.siteId = this.$el.attributes['data-site-id'].value,
      this.getNotifications(this.variables)
    }
  })
  vm.$mount(el)
}
